import { render, staticRenderFns } from "./RePwd.vue?vue&type=template&id=7c7efbaa&scoped=true&"
import script from "./RePwd.vue?vue&type=script&lang=js&"
export * from "./RePwd.vue?vue&type=script&lang=js&"
import style0 from "styles/views/rePwd/rePwd.css?vue&type=style&index=0&id=7c7efbaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7efbaa",
  null
  
)

export default component.exports